import React from 'react';
/*
import {
  hf,
  ht,
  cr,
  a,
  f,
  gs,
  ls,
  useMsgz,
  useLdrz,
  BoxC,
  BtnC,
  GridC,
  IptC,
  LblC,
  MsgC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as MsgC from "./_cccMsgC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useLdrz } from "./_csLdr";
import { useMsgz } from "./_csMdlMsg";
import * as ht from './_ht';
import * as hf from './_hf';

import * as icm from './icm';
import * as icv from './icv';
import * as ihv from './ihv';

import * as icvI18___Mz from './icvI18___Mz';

let $i18z = icvI18___Mz.ilzI18z();
let $mail11 = ``;
let $mail12 = ``;
let $mail21 = ``;
let $mail22 = ``;
let $mail31 = ``;
let $mail32 = ``;

export const N = (pz: {
  sPz: ht.dz,
}) => {

  const _gUserz = gs.useUserz();
  const _i19ra1220i = _gUserz.crt.i19rz?.i19ra1220i;
  const _i19ra3100jz = hf.j(_gUserz.crt.i19rz?.i19ra3100j ?? '');
  //hf.l(`icvI18D11Co 35: ${hf.s(_gUserz.crt.i19rz)}`);
  //hf.l(`icvI18D11Co 36: ${hf.s(_i19ra3100jz)}`);

  const _gStgz = gs.useStgz();

  const _udtThis = ls.udtThis();
  const _sMsgz = useMsgz();
  const _sLdrz = useLdrz();

  React.useEffect(() => {
    cmFTH.loadAllAsync({
      frcUdt: _udtThis,
      bfrAsync: () => [
        icvI18___Mz.loadI18rDzAsync({
          i18r_fst: _gUserz.crt.i18rz._fst,
        })
          .then((_dz: ht.dz) => {
            $i18z = _dz;
            $mail11 = $i18z.i18rz.i18ra4110s;
            $mail12 = $i18z.i18rz.i18ra4110s;
            $mail21 = $i18z.i18rz.i18ra4210s;
            $mail22 = $i18z.i18rz.i18ra4210s;
            $mail31 = $i18z.i18rz.i18ra4310s;
            $mail32 = $i18z.i18rz.i18ra4310s;
            //hf.l(`icvI18D11Co 38: ${hf.s($i18z)}`);
          })
      ]
    })
  }, [])

  const _send = async () => {
    _sLdrz.show();
    const _b = await hf.ectSrlAsync([
      async () => {
        let _b = true;
        if (
          $mail11 != $mail12 ||
          $mail21 != $mail22 ||
          $mail31 != $mail32
        ) _b = false;
        if (!_b) {
          _sMsgz.show({
            textCz: {
              textz: {
                pfx: `変更後のメールアドレスと再入力したメールアドレスが異なってます`
              }
            }
          })
        }
        return _b;
      },
      /*
            async () => {
              let _b = true;
              if (
                $mail11 == $mail21 ||
                $mail11 == $mail31 ||
                $mail21 == $mail31
              ) _b = false;
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: `変更後のメールアドレスが重複しています`
                    }
                  }
                })
              }
              return _b;
            }
      */
    ])
    if (_b) {

      $i18z.i18rz.i18ra4110s = $mail11;
      $i18z.i18rz.i18ra4210s = $mail21;
      $i18z.i18rz.i18ra4310s = $mail31;

      const _b = await icvI18___Mz.chkI18zAsync({
        role: 'd',
        i18z: $i18z,
        sMsgz: _sMsgz,
        chkStep: 0,
      })

      if (_b) {
        await icvI18___Mz.saveI18rDzAsync({
          i18z: $i18z,
        });

        const _mailz = ihv.mailz.lz.grtMailArsAdd({
          i18rz: $i18z.i18rz,
        });

        await icm.gasMailAsync({
          //        i18rz: $i18z.i18rz,
          i18r_fst: $i18z.i18rz._fst,
          //_31r_fst: _gUserz.crt._31rz._fst,
          _31r_fst: $i18z.i18rz.i18r_31r1f,
          ..._mailz
        });

        _sLdrz.hide();
        if (pz.sPz.crt.ctt == 's' && hf.i(_i19ra1220i, [10])) {
          cr.moveTo({
            pageName: 'icvHomeD10Rz',
          })
        }
        if (pz.sPz.crt.ctt == 's' && hf.i(_i19ra1220i, [20, 30])) {
          pz.sPz.set({
            steps: [0],
          });
        }
        if (pz.sPz.crt.ctt == 'i' && hf.i(_i19ra1220i, [10])) {
          pz.sPz.set({
            steps: [2],
          });
        }
        if (pz.sPz.crt.ctt == 'i' && hf.i(_i19ra1220i, [20, 30])) {
          pz.sPz.set({
            steps: [1],
          });
        }
      }
      else {
        _sLdrz.hide();
      }
    }
    else {
      _sLdrz.hide();
    }
  }


  return (

    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a('dwx/120 dw/f fd/csc mh/a'),
      oClds: [

        cr.c(LblC.N, {
          key: -10,
          boxStlz: a(`dw/f mb/3`),
          lblCz: {
            boxStlz: a(`dw/f fd/rcc mb/2`),
            textz: {
              pfx:
                pz.sPz.crt.ctt == 's' ?
                  //                  'メールアドレスの変更'
                  '登録メールアドレスの追加・変更'
                  : pz.sPz.crt.ctt == 'i' ?
                    'メールアドレスの登録'
                    : '',
              stlz: a(`tb ts/l`),
            }
          },
          cttCz: {
            boxStlz: a(`dw/f fd/csc`),
            oClds: [

              hf.i(pz.sPz.crt.ctt, ['i', 's']) ?
                cr.c(MsgC.N, {
                  key: -10,
                  boxStlz: a(`dwx/100`),
                  cz: {
                    ls: [
                      {
                        mkrCz: {
                          textz: {
                            pfx: '・',
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: '施設予約に利用したいメールアドレスを入力ください。',
                          }
                        }
                      },
                    ]
                  }
                })
                : null,

              hf.i(pz.sPz.crt.ctt, ['i', 's']) ?
                cr.c(MsgC.N, {
                  key: -20,
                  boxStlz: a(`dwx/100 mb/2 p/2`),
                  cz: {
                    ls: [
                      {
                        mkrCz: {
                          textz: {
                            pfx: '※',
                            //stlz: a('ts/s'),
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: 'メールアドレスは、最大３つまで登録可能です。正常にメールアドレスの登録が完了すると、【メールアドレス登録のご連絡】というタイトルの確認メールが5分以内に自動で届きます。',
                            //stlz: a('ts/s'),
                          }
                        }
                      },
                      {
                        mkrCz: {
                          textz: {
                            pfx: '※',
                            //stlz: a('ts/s'),
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: '上記のメールが届かなかった場合、メールアドレスが正しく登録されていない可能性がございます。その場合は、もう一度最初から、お試しください。',
                            //stlz: a('ts/s'),
                          }
                        }
                      },
                      {
                        mkrCz: {
                          textz: {
                            pfx: '※',
                            //stlz: a('ts/s'),
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: 'メールが届かない場合、迷惑メール防止サービスをご利用されているお客様は、迷惑メールとして判定されていないかのご確認をお願いします。',
                            //stlz: a('ts/s'),
                          }
                        }
                      },
                      {
                        mkrCz: {
                          textz: {
                            pfx: '※',
                            //stlz: a('ts/s'),
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: 'PCからのメールを拒否されており、ドメイン単位での受信許可が可能な方は「f-supportsys2.com」から届くメールの受信許可設定をお願いいたします。',
                            //stlz: a('ts/s'),
                          }
                        }
                      },
                      {
                        mkrCz: {
                          textz: {
                            pfx: '※',
                            //stlz: a('ts/s'),
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: '何度試してもメールアドレスがうまく登録されない場合は、お手数ですが窓口までご相談ください。',
                            //stlz: a('ts/s'),
                          }
                        }
                      }
                    ]
                  }
                })
                : null,

              !_i19ra3100jz || _i19ra3100jz[110] != 1 ?
                cr.c(GridC.N, {
                  key: -210,
                  abtType: 'nolineCmnz',
                  //                boxStlz: a(`dw/75 f/n`),
                  boxStlz: a(`dwx/75 f/n pt/1`),
                  lineCs: [
                    pz.sPz.crt.ctt == 's' ?
                      {
                        boxStlz: a(`mb/1`),
                        cellCs: [
                          {
                            oClds: [
                              cr.c(LblC.N, {
                                key: -10,
                                abtType:
                                  cr.d('p') ?
                                    '_hzlz'
                                    : '_vclz',
                                lblCz: {
                                  boxStlz: a(`dw/35`),
                                  textz: {
                                    pfx: '登録メールアドレス１：',
                                  }
                                },
                                cttCz: {
                                  oClds: [
                                    cr.c(IptC.S, {
                                      key: -10,
                                      cz: {
                                        bEdit: false,
                                        iptType: 'text',
                                        vle: hf.f($i18z.i18rz.i18ra4110s) ? $i18z.i18rz.i18ra4110s : '未登録',
                                      },
                                    })
                                  ]
                                }
                              })
                            ]
                          },
                        ]
                      }
                      : null,
                    {
                      boxStlz: a(`mb/1`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType:
                                cr.d('p') ?
                                  '_hzlz'
                                  : '_vclz',
                              lblCz: {
                                boxStlz: a(`dw/35`),
                                textz: {
                                  //pfx: '変更：',
                                  pfx: 'メール（主）：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'text',
                                      vle: $mail11,
                                      onChg: (_s: ht.s) => {
                                        $mail11 = _s;
                                      }
                                    },
                                  })
                                ]
                              }
                            })
                          ]
                        },
                      ]
                    },
                    {
                      boxStlz: a(`mb/1`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType:
                                cr.d('p') ?
                                  '_hzlz'
                                  : '_vclz',
                              lblCz: {
                                boxStlz: a(`dw/35`),
                                textz: {
                                  //pfx: '変更の再入力：',
                                  pfx: 'メール（主）の再入力：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'text',
                                      vle: $mail12,
                                      onChg: (_s: ht.s) => {
                                        $mail12 = _s;
                                      }
                                    },
                                  })
                                ]
                              }
                            })
                          ]
                        },
                      ]
                    },
                  ]
                })
                : null,

              !_i19ra3100jz || _i19ra3100jz[120] != 1 ?
                cr.c(GridC.N, {
                  key: -220,
                  abtType: 'nolineCmnz',
                  //                boxStlz: a(`dw/75 f/n mb/1`),
                  boxStlz: a(`bc/lt9 bs/ds bwt/0.5 dwx/75 f/n mt/1 pt/2`),
                  lineCs: [
                    pz.sPz.crt.ctt == 's' ?
                      {
                        //                    boxStlz: a(`bc/lt9 bs/ds bwt/0.5 mv/1 pt/1`),
                        boxStlz: a(`mb/1`),
                        cellCs: [
                          {
                            oClds: [
                              cr.c(LblC.N, {
                                key: -10,
                                abtType:
                                  cr.d('p') ?
                                    '_hzlz'
                                    : '_vclz',
                                lblCz: {
                                  boxStlz: a(`dw/35`),
                                  textz: {
                                    pfx: '登録メールアドレス２：',
                                  }
                                },
                                cttCz: {
                                  oClds: [
                                    cr.c(IptC.S, {
                                      key: -10,
                                      cz: {
                                        bEdit: false,
                                        iptType: 'text',
                                        vle: hf.f($i18z.i18rz.i18ra4210s) ? $i18z.i18rz.i18ra4210s : '未登録',
                                      },
                                    })
                                  ]
                                }
                              })
                            ]
                          },
                        ]
                      }
                      : null,

                    {
                      /*
                                          boxStlz: 
                                            pz.sPz.crt.ctt == 's' ?
                                              a(`mb/1`)
                                            : pz.sPz.crt.ctt == 'i' ?
                                              a(`bc/lt9 bs/ds bwt/0.5 mb/1 pt/1`)
                                            : undefined,
                      */
                      boxStlz: a(`mb/1`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType:
                                cr.d('p') ?
                                  '_hzlz'
                                  : '_vclz',
                              lblCz: {
                                boxStlz: a(`dw/35`),
                                textz: {
                                  //pfx: '追加・変更：'
                                  pfx: 'メール（副１）：'
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'text',
                                      vle: $mail21,
                                      onChg: (_s: ht.s) => {
                                        $mail21 = _s;
                                      }
                                    },
                                  })
                                ]
                              }
                            })
                          ]
                        },
                      ]
                    },
                    {
                      boxStlz: a(`mb/1`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType:
                                cr.d('p') ?
                                  '_hzlz'
                                  : '_vclz',
                              lblCz: {
                                boxStlz: a(`dw/35`),
                                textz: {
                                  //pfx: '追加・変更の再入力：',
                                  pfx: 'メール（副１）の再入力：'
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'text',
                                      vle: $mail22,
                                      onChg: (_s: ht.s) => {
                                        $mail22 = _s;
                                      }
                                    },
                                  })
                                ]
                              }
                            })
                          ]
                        },
                      ]
                    },
                  ]
                })
                : null,

              !_i19ra3100jz || _i19ra3100jz[130] != 1 ?
                cr.c(GridC.N, {
                  key: -230,
                  abtType: 'nolineCmnz',
                  //                boxStlz: a(`dw/75 f/n`),
                  boxStlz: a(`bc/lt9 bs/ds bwt/0.5 dwx/75 f/n mt/1 pt/2`),
                  lineCs: [
                    pz.sPz.crt.ctt == 's' ?
                      {
                        //                    boxStlz: a(`bc/lt9 bs/ds bwt/0.5 mv/1 pt/1`),
                        boxStlz: a(`mb/1`),
                        cellCs: [
                          {
                            oClds: [
                              cr.c(LblC.N, {
                                key: -10,
                                abtType:
                                  cr.d('p') ?
                                    '_hzlz'
                                    : '_vclz',
                                lblCz: {
                                  boxStlz: a(`dw/35`),
                                  textz: {
                                    pfx: '登録メールアドレス３：',
                                  }
                                },
                                cttCz: {
                                  oClds: [
                                    cr.c(IptC.S, {
                                      key: -10,
                                      cz: {
                                        bEdit: false,
                                        iptType: 'text',
                                        vle: hf.f($i18z.i18rz.i18ra4310s) ? $i18z.i18rz.i18ra4310s : '未登録',
                                      },
                                    })
                                  ]
                                }
                              })
                            ]
                          },
                        ]
                      }
                      : null,

                    {
                      /*
                                          boxStlz: 
                                            pz.sPz.crt.ctt == 's' ?
                                                a(`mb/1`)
                                            : pz.sPz.crt.ctt == 'i' ?
                                              a(`bc/lt9 bs/ds bwt/0.5 mb/1 pt/1`)
                                            : undefined,
                      */
                      boxStlz: a(`mb/1`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType:
                                cr.d('p') ?
                                  '_hzlz'
                                  : '_vclz',
                              lblCz: {
                                boxStlz: a(`dw/35`),
                                textz: {
                                  //pfx: '追加・変更：',
                                  pfx: 'メール（副２）：'
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'text',
                                      vle: $mail31,
                                      onChg: (_s: ht.s) => {
                                        $mail31 = _s;
                                      }
                                    },
                                  })
                                ]
                              }
                            })
                          ]
                        },
                      ]
                    },
                    {
                      boxStlz: a(`mb/1`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType:
                                cr.d('p') ?
                                  '_hzlz'
                                  : '_vclz',
                              lblCz: {
                                boxStlz: a(`dw/35`),
                                textz: {
                                  //pfx: '追加・変更の再入力：',
                                  pfx: 'メール（副２）の再入力：'
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'text',
                                      vle: $mail32,
                                      onChg: (_s: ht.s) => {
                                        $mail32 = _s;
                                      }
                                    },
                                  })
                                ]
                              }
                            })
                          ]
                        },
                      ]
                    }

                  ]
                })
                : null,
            ]
          }


        }),

        cr.c(BoxC.N, {
          key: -20,
          boxStlz:
            cr.chkDvc() == 'p' ?
              a(`dw/f fd/rac`)
              : a(`dw/f fd/crac`),
          oClds: [

            cr.c(BtnC.N, {
              key: -20,
              abtType: 'backCmnz',
              boxStlz: a(`dh/10 mb/2`),
              lblCz: {
                textz: {
                  pfx: '前の画面に戻る',
                }
              },
              pslPtyz: {
                onPress: () => {
                  pz.sPz.set({
                    steps: [0],
                  });
                },
              },
            }),

            cr.c(BtnC.N, {
              key: -30,
              abtType: 'stgz',
              boxStlz: a(`dh/10 mb/2`),
              lblCz: {
                textz: {
                  pfx:
                    pz.sPz.crt.ctt == 's' ?
                      '登録されているメールアドレスを変更'
                      : pz.sPz.crt.ctt == 'i' ?
                        'メールアドレスを登録'
                        : '',
                }
              },
              pslPtyz: {
                onPress: _send,
              },
            }),

          ]
        })


        /*
                cr.c(BrdC.N, {
                  key: -10,
                  abtType: 'stgz',
                  ttlCz: {
                    textz: {
                      pfx: 'メールアドレス変更',
                    }
                  },
                  dtlCz: {
                    oClds: [
        
                      cr.c(FldC.N, {
                        key: -10,
                        abtType: 'stgz',
                        mainz: {
                          lblCz: {
                            textz: {
                              pfx: '現在登録されているメールアドレス(主)：',
                            }
                          },
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              abtType: 'stgz',
                              cz: {
                                bEdit: false,
                                iptType: 'text',
                                vle: 'test@maif.com',
                              },
                            })
                          ]
                        },
                      }),
        
                      cr.c(FldC.N, {
                        key: -20,
                        abtType: 'stgz',
                        mainz: {
                          lblCz: {
                            textz: {
                              pfx: '変更後のメールアドレス(主)：',
                            }
                          },
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              abtType: 'stgz',
                              cz: {
                                bEdit: true,
                                iptType: 'text',
                              },
                            })
                          ]
                        },
                      }),
        
                      cr.c(FldC.N, {
                        key: -30,
                        abtType: 'stgz',
                        boxStlz: a('bc/lt5 bs/dt bwb/1 mb/1'),
                        mainz: {
                          lblCz: {
                            textz: {
                              pfx: '同じメールアドレス(主)を再入力：',
                            }
                          },
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              abtType: 'stgz',
                              cz: {
                                bEdit: true,
                                iptType: 'text',
                              },
                            })
                          ]
                        },
                        subz: {
                          msgCz: {
                            textz: {
                              pfx: 'コピー＆ペーストしないでください',
                            }
                          },
                        }
                      }),
        
                      cr.c(FldC.N, {
                        key: -10,
                        abtType: 'stgz',
                        mainz: {
                          lblCz: {
                            textz: {
                              pfx: '現在登録されているメールアドレス(副1)：',
                            }
                          },
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              abtType: 'stgz',
                              cz: {
                                bEdit: false,
                                iptType: 'text',
                                vle: 'test@maif.com',
                              },
                            })
                          ]
                        },
                      }),
        
                      cr.c(FldC.N, {
                        key: -20,
                        abtType: 'stgz',
                        mainz: {
                          lblCz: {
                            textz: {
                              pfx: '変更後のメールアドレス(副1)：',
                            }
                          },
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              abtType: 'stgz',
                              cz: {
                                bEdit: true,
                                iptType: 'text',
                              },
                            })
                          ]
                        },
                      }),
        
                      cr.c(FldC.N, {
                        key: -30,
                        abtType: 'stgz',
                        boxStlz: a('bc/lt5 bs/dt bwb/1 mb/1'),
                        mainz: {
                          lblCz: {
                            textz: {
                              pfx: '同じメールアドレス(副1)を再入力：',
                            }
                          },
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              abtType: 'stgz',
                              cz: {
                                bEdit: true,
                                iptType: 'text',
                              },
                            })
                          ]
                        },
                        subz: {
                          msgCz: {
                            textz: {
                              pfx: 'コピー＆ペーストしないでください',
                            }
                          },
                        }
                      }),
        
                      cr.c(FldC.N, {
                        key: -10,
                        abtType: 'stgz',
                        mainz: {
                          lblCz: {
                            textz: {
                              pfx: '現在登録されているメールアドレス(副2)：',
                            }
                          },
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              abtType: 'stgz',
                              cz: {
                                bEdit: false,
                                iptType: 'text',
                                vle: 'test@maif.com',
                              },
                            })
                          ]
                        },
                      }),
        
                      cr.c(FldC.N, {
                        key: -20,
                        abtType: 'stgz',
                        mainz: {
                          lblCz: {
                            textz: {
                              pfx: '変更後のメールアドレス(副2)：',
                            }
                          },
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              abtType: 'stgz',
                              cz: {
                                bEdit: true,
                                iptType: 'text',
                              },
                            })
                          ]
                        },
                      }),
        
                      cr.c(FldC.N, {
                        key: -30,
                        abtType: 'stgz',
                        mainz: {
                          lblCz: {
                            textz: {
                              pfx: '同じメールアドレス(副2)を再入力：',
                            }
                          },
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              abtType: 'stgz',
                              cz: {
                                bEdit: true,
                                iptType: 'text',
                              },
                            })
                          ]
                        },
                        subz: {
                          msgCz: {
                            textz: {
                              pfx: 'コピー＆ペーストしないでください',
                            }
                          },
                        }
                      }),
        
                      cr.c(BtnC.N, {
                        key: -40,
                        abtType: 'stgz',
                        boxStlz: a('mv/2'),
                        lblCz: {
                          textz: {
                            pfx: '登録されているメールアドレスを変更',
                          }
                        },
                        pslPtyz: {
                          onPress: () => {
                            pz.sPz.set({
                              step: 0,
                            });
                          }
                        },
                      }),
        
                    ],
                  },
                }),
        */

      ]
    })

  );
};
